import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2d7835a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-left flex-1 mr-auto" }, "已選商品清單", -1))
const _hoisted_3 = { class: "list-content" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-5" }, "購物車內目前沒有商品", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list-content-title flex gap-8 pt-[12px] px-[32px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, "商品項目"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[120px] text-center" }, "數量"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[150px] text-center" }, "小計"),
  /*#__PURE__*/_createElementVNode("div", { class: "w-[30px]" })
], -1))
const _hoisted_8 = { class: "list-content-body" }
const _hoisted_9 = { class: "list-content-layout" }
const _hoisted_10 = { class: "image" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = { class: "name cursor-pointer" }
const _hoisted_13 = { class: "max880:text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_14 = { class: "text-[11px] text-light-gary-text-color" }
const _hoisted_15 = { class: "number" }
const _hoisted_16 = { class: "price" }
const _hoisted_17 = { class: "text-sm leading-10 items-center text-gary-text-color tracking-[.06em] text-center" }
const _hoisted_18 = { class: "trash" }

import {
  onBeforeUnmount,
  onMounted,
  PropType,
  provide,
  reactive,
  ref,
  watch,
  nextTick
} from 'vue'
import store from '@/composition/store'
import cartStore from '@/composition/cartStore'
import { OrderShoppingCartCmdy } from '@/types/ResponseType'
import { useToast, POSITION } from 'vue-toastification'
import { setShoppingCartInLocal } from '@/utils/localStorageHandler'
import { unescapeHTML } from '@/utils/utils'
import SquareItemFullImage from '@/components/SquareItemFullImage.vue'
import InputWithButton from '@/components/common/InputWithButton.vue'
import UnderLine from '@/components/common/UnderLine.vue'
import cloneDeep from 'lodash/cloneDeep'
import { COLOR_TYPE, PromotionProductType } from '@/types/PromotionType'
import ModalConfirm from '@/components/modal/ConfirmModal.vue'
import { ConfirmModal } from '@/types/ConfirmModal'


export default /*#__PURE__*/_defineComponent({
  __name: 'RedGreenCartModal',
  props: {
  promotionData: {
    type: Object as PropType<PromotionProductType>,
    required: true
  },
  clickableRef: {
    type: Object as PropType<HTMLElement | null>,
    default: null
  }
},
  emits: ['openControl'],
  setup(__props, { expose, emit: emits }) {

const props = __props

provide('store', store)
provide('cartStore', cartStore)
const toast = useToast()
const isShown = ref(false)
const currentCartColor = ref<COLOR_TYPE | null>(null)
const listContainer = ref<HTMLElement | null>(null)
const confirmModal = ref<ConfirmModal | null>(null)
const tempColorCartCmdyList = reactive<OrderShoppingCartCmdy[]>([])



const subtractClick = (
  shoppingCartItem: OrderShoppingCartCmdy,
  index: any,
  type = 'cmdy',
  subIndex: number
) => {
  if (type === 'cmdy' && shoppingCartItem.CmdyQty === 1) {
    return
  }
  if (
    type === 'addOn' &&
    shoppingCartItem.AddOnCmdyList[subIndex].CmdyQty === 1
  ) {
    return
  }

  if (type !== 'cmdy') {
    if (type === 'addOn') {
      shoppingCartItem.AddOnCmdyList[subIndex].CmdyQty -= 1
    }
  } else {
    shoppingCartItem.CmdyQty -= 1
  }
  itemUpdate(shoppingCartItem, index, type, subIndex)
}

const addClick = (
  shoppingCartItem: OrderShoppingCartCmdy,
  index: any,
  type = 'cmdy',
  subIndex: number
) => {
  if (shoppingCartItem.CmdyQty >= 100) {
    shoppingCartItem.CmdyQty = 100
    itemUpdate(shoppingCartItem, index, 'cmdy', 0)
    return toast.warning('已達訂購上限', {
      position: POSITION.TOP_CENTER
    })
  }

  if (type !== 'cmdy') {
    if (type === 'addOn') {
      shoppingCartItem.AddOnCmdyList[subIndex].CmdyQty += 1
    }
  } else {
    shoppingCartItem.CmdyQty += 1
  }
  itemUpdate(shoppingCartItem, index, type, subIndex)
}

const itemUpdate = (
  itemInfo: any,
  index: any,
  type = 'cmdy',
  subIndex: number
) => {
  if (itemInfo.CmdyQty === '' || parseInt(itemInfo.CmdyQty) === 0) {
    itemInfo.CmdyQty = 1
    itemUpdate(itemInfo, index, 'cmdy', 0)
  } else {
    console.log(itemInfo.CmdyQty)
    itemInfo.CmdyQty = parseInt(itemInfo.CmdyQty)
    if (store.state.isLogin) {
      if (type === 'addOn') {
        cartStore
          .updateShoppingCart(itemInfo.AddOnCmdyList[subIndex])
          .then((res) => {
            cartStore.fetchShoppingCartList()
          })
      } else {
        cartStore.updateShoppingCart(itemInfo).then((res) => {
          cartStore.fetchShoppingCartList()
        })
      }
    } else {
      // 找到商品在原始購物車陣列中的正確索引
      const realIndex = cartStore.state.orderShoppingCartCmdyList.findIndex(
        (item: OrderShoppingCartCmdy) => item.CmdyId === itemInfo.CmdyId
      )

      if (realIndex !== -1) {
        setShoppingCartInLocal(
          itemInfo as OrderShoppingCartCmdy,
          'update',
          realIndex
        )
        cartStore.fetchShoppingCartList()
      } else {
        console.error('找不到商品在購物車中的位置:', itemInfo.CmdyId)
      }
    }
  }
}

// 將購物車資料篩選到 tempColorCartCmdyList
const getTempList = (_color: COLOR_TYPE) => {
  const colorItems = props.promotionData.colors[_color]
  const colorIds = new Set(colorItems.map((item) => item.id))

  // 清空重新加入篩選結果
  tempColorCartCmdyList.length = 0
  tempColorCartCmdyList.push(
    ...cloneDeep(
      cartStore.state.orderShoppingCartCmdyList.filter((item: OrderShoppingCartCmdy) =>
        colorIds.has(item.CmdyId)
      )
    )
  )
}

const leaveBlock = () => {
  if (!listContainer.value || !props.clickableRef) return

  closeCart()
}

// 開啟彈跳視窗
const openCart = (_color: COLOR_TYPE) => {
  // 取得 tempColorCartCmdyList 購物車資料
  getTempList(_color)

  // open
  currentCartColor.value = _color
  isShown.value = true

  nextTick(() => {
    listContainer.value?.addEventListener('mouseleave', leaveBlock)
  })

  emits('openControl', true)
}

// 關閉彈跳視窗
const closeCart = () => {
  // close
  isShown.value = false
  currentCartColor.value = null

  listContainer.value?.removeEventListener('mouseleave', leaveBlock)

  emits('openControl', false)
}

// 處理刪除確認
const handleDelete = async (
  shoppingCartItem: OrderShoppingCartCmdy,
  shoppingCartItemIndex: number
) => {
  try {
    const _confirmModal = confirmModal.value as ConfirmModal
    await _confirmModal.createConfirm('', '確認刪除此商品？', false)

    // 在未登入狀態下，需要找到商品在原始購物車陣列中的正確索引
    let realIndex = shoppingCartItemIndex
    if (!store.state.isLogin) {
      realIndex = cartStore.state.orderShoppingCartCmdyList.findIndex(
        (item: OrderShoppingCartCmdy) => item.CmdyId === shoppingCartItem.CmdyId
      )

      if (realIndex === -1) {
        console.error('找不到要刪除的商品:', shoppingCartItem.CmdyId)
        return
      }
    }

    // 使用者確認後才執行刪除
    cartStore.delShoppingCart(
      shoppingCartItem.OrderShoppingCartId,
      realIndex,
      'cmdy',
      0
    )

    // 刪除後不關閉視窗，讓使用者可以繼續操作
    // 當 tempColorCartCmdyList 為空時，會自動顯示「購物車內目前沒有商品」
  } catch {
    // 使用者取消，不執行任何動作
  }
}

// 點擊指定區域外時，關閉彈跳視窗
const outerClick = (event: MouseEvent) => {
  if (!listContainer.value || !props.clickableRef) return

  // 檢查是否點擊在 ModalConfirm 上（刪除確認對話框）
  const modalElement = document.querySelector('.modal-container')
  if (modalElement && modalElement.contains(event.target as Node)) {
    return
  }

  // 檢查是否點擊在 toast 提示上
  const toastElement = document.querySelector('.Vue-Toastification__container')
  if (toastElement && toastElement.contains(event.target as Node)) {
    return
  }

  if (
    !listContainer.value.contains(event.target as Node) &&
    !props.clickableRef.contains(event.target as Node)
  ) {
    closeCart()
  }
}

// 更新 tempColorCartCmdyList
watch(
  () => cartStore.state.orderShoppingCartCmdyList,
  () => {
    if (!isShown.value || !currentCartColor.value) return // 如果未開啟則不需要更新
    getTempList(currentCartColor.value)
  }
)

onMounted(() => {
  document.addEventListener('click', outerClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', outerClick)
})

expose({ openCart, handleDelete })

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "slide-up" }, {
      default: _withCtx(() => [
        (isShown.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                ref_key: "listContainer",
                ref: listContainer,
                class: "list-container"
              }, [
                _createElementVNode("div", { class: "list-header" }, [
                  _hoisted_2,
                  _createElementVNode("button", {
                    type: "button",
                    onClick: closeCart
                  }, " × ")
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (tempColorCartCmdyList.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_7,
                        _createElementVNode("ul", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tempColorCartCmdyList, (shoppingCartItem, shoppingCartItemIndex) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: shoppingCartItem.OrderShoppingCartId,
                              class: "flex flex-col"
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(SquareItemFullImage, {
                                    width: '60px',
                                    image: 
                          shoppingCartItem.CmdyImage?.PcWeb ||
                          shoppingCartItem.CmdyImageList?.slice(0, 1)[0].Image.PcWeb ||
                          ''
                        
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(unescapeHTML)(
                              shoppingCartItem.Name ||
                              shoppingCartItem.CmdyName
                            )), 1),
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(unescapeHTML)(
                              shoppingCartItem.SubName ||
                              shoppingCartItem.CmdySubName ||
                              ''
                            )), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(InputWithButton, {
                                      maxNumber: 100,
                                      modelValue: shoppingCartItem.CmdyQty,
                                      "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.CmdyQty) = $event),
                                      onAddClick: ($event: any) => (
                            addClick(
                              shoppingCartItem,
                              shoppingCartItemIndex,
                              'cmdy',
                              0
                            )
                          ),
                                      onSubtractClick: ($event: any) => (
                            subtractClick(
                              shoppingCartItem,
                              shoppingCartItemIndex,
                              'cmdy',
                              0
                            )
                          ),
                                      onBlur: ($event: any) => (
                            itemUpdate(
                              shoppingCartItem,
                              shoppingCartItemIndex,
                              'cmdy',
                              0
                            )
                          )
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"])
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, " NT. " + _toDisplayString(shoppingCartItem.TotalAmount?.toString() ||
                            (
                              shoppingCartItem.MaxUnitFeeReal *
                              shoppingCartItem.CmdyQty
                            ).toString()), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_Icon, {
                                      class: "cursor-pointer",
                                      onClick: ($event: any) => (handleDelete(shoppingCartItem, shoppingCartItemIndex)),
                                      iconName: "circle_close",
                                      width: '24px'
                                    }, null, 8, ["onClick"])
                                  ])
                                ])
                              ]),
                              _createVNode(UnderLine, { class: "mt-[12px] mb-0" })
                            ]))
                          }), 128))
                        ])
                      ], 64))
                ])
              ], 512)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ModalConfirm, {
      ref_key: "confirmModal",
      ref: confirmModal
    }, null, 512)
  ], 64))
}
}

})